{
  "period.member.editAction": "Edit membership",
  "period.member.editTitle": "Edit period membership",
  "period.member.saveAction": "Save membership",
  "period.member.role": "Role in this period",
  "period.member.note": "Period-specific note",
  "period.member.order": "Display order",
  "period.member.error": "The membership could not be updated. Your changes are still available to retry."
}
